import React from 'react';
import { makeStyles } from '@mui/styles';
import { Section, SectionAlternate } from 'components/organisms';
import {
  Contact,
  Hero,
} from './components';

import { support } from './data';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    width: '100%',
  },
  sectionNoPaddingTop: {
    paddingTop: 0,
  },
  sectionPartners: {
    boxShadow: '0 5px 20px 0 rgba(90, 202, 157, 0.05)',
    '& .section-alternate__content': {
      paddingTop: theme.spacing(5),
      paddingBottom: theme.spacing(5),
    },
  },
}));

const About = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Hero id="support"/>
      <Contact id="support-contact" data={support}/>
    </div>
  );
};

export default About;
